import React from 'react'
import AccountProfile from '../profile/AccountProfile'

const ALLOWED_ORIGINS = ["https://www.evokeeclinic.com", "http://localhost:8000", "https://oyster-app-skvco.ondigitalocean.app" ]

const AdminViewController = () => {
    const [userData, setUserData] = React.useState()
    
    window.addEventListener('message', function(event) {
        var origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
        if (ALLOWED_ORIGINS.includes(origin)) setUserData(event.data)
    }, false);

    if (!userData) return <div/>

  return (
      <>
        <style>
            {`
                .main-sidebar.is-bordered {
                    display: none;
                }

                .view-wrapper {
                    width: 100%;
                    margin: 0;
                }

                .huro-hamburger.nav-trigger.push-resize {
                    display: none;
                }

                .form-header.stuck-header.is-stuck {
                    margin-left: 0;
                    width: 100%;
                }

                .form-header.stuck-header.is-stuck .right {
                    display: none;
                }

                .form-header-inner .right {
                   
                }

                .message {
                    display: none;
                }

                .saas-billing-wrapper .plans-wrapper .left .plans .plan input:checked + .plan-inner {
                    border-color: #37514b;
                    -webkit-box-shadow: -1px 3px 10px 0 rgba(0,0,0,.06);
                    box-shadow: -1px 3px 10px 0 rgba(0,0,0,.06);
                }
            `}
        </style>
        <AccountProfile 
            readOnly={false} userData={userData}
            onUpdated={{
                btnText: "Reload Page",
                message: "Profile has been updated!, please click the button below to reload page.",
                action: () => {
                    window.parent.postMessage({ "action": "reload" }, "*")
                }
            }}
            />
      </>
  )
}

export default AdminViewController